import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HubLogoModule } from '../hub-logo/hub-logo.module';
import { TrWrapperTwoColumnsModule } from '../tr-wrapper-two-columns/tr-wrapper-left-column.module';
import { ForgotPasswordFormComponent } from './forgot-password-form.component';
import { TrSpinnerButtonDirectiveModule } from '../../directives';
import { CopyPasteBlockDirectiveModule } from '../../directives/copy-paste-block/copy-paste-block.module';


@NgModule({
    imports: [
        CommonModule,
        TrWrapperTwoColumnsModule,
        HubLogoModule,
        ReactiveFormsModule,
        CopyPasteBlockDirectiveModule,
        TrSpinnerButtonDirectiveModule,
        FormsModule,
    ],
    exports: [ ForgotPasswordFormComponent ],
    declarations: [ ForgotPasswordFormComponent ],
})
export class ForgotPasswordFormModule {}
